import { Box, Button, Grid, Link, Typography } from '@mui/material';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { OTPContainer } from './components/OTPContainer';
import TestimonialsTwoCarousel from './components/TestimonialsCarousel';

export const InsertBusinessPhoneNumber = () => {
  const navigate = useNavigate();
  const inputRefs = useRef<Array<any>>([]);

  const handleInputChange = (index: number, event: any) => {
    const value = event.target.value;
    if (value.length > 1) {
      event.target.value = value.slice(0, 1);
      return;
    }
    if (value.length === 1 && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleGoToNextPage = () => {
    navigate('/onboarding/v2/confirm-business-phone-number');
  };

  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#19191C',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 750,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
          }}
        >
          <img
            src="/icon/artwork.svg"
            alt=""
            style={{
              width: 180,
              height: 'auto',
              marginBottom: 0,
            }}
          />
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="h6"
            fontWeight={400}
            fontSize={16}
            mb={5}
            mt={1}
            align="center"
            sx={{ width: '100%' }}
          >
            Enter your business phone number
          </Typography>
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="subtitle1"
            fontWeight={400}
            mb={2}
            align="center"
            sx={{ width: '100%' }}
          >
            Verification code sent to +1 123 123 1234{' '}
            <Link href="#" variant="body2" color="#4949C8" underline="hover">
              change
            </Link>
          </Typography>
          <OTPContainer
            length={6}
            onChange={(value) => console.log('OTP value:', value)}
            onComplete={(value) => console.log('OTP complete:', value)}
          />
          <Box sx={{ width: '100%', maxWidth: 380, textAlign: 'left', mb: 1 }}>
            <Link
              href="#"
              color="#4949C8"
              underline="hover"
              sx={{ fontSize: 16, fontWeight: 400 }}
            >
              Resend code
            </Link>
          </Box>
          <Link
            href="#"
            color="#4949C8"
            underline="hover"
            sx={{ fontSize: 16, fontWeight: 400, mt: 3, mb: 1 }}
          >
            Sign up using email
          </Link>
          <Typography variant="body2" mt={4} textAlign="center" color="#fff">
            Already have an account?{' '}
            <Link href="#" color="#4949C8" underline="hover">
              Sign in
            </Link>
          </Typography>
          <Button
            variant="contained"
            sx={{
              fontSize: 16,
              mt: 4,
              p: 2,
              width: '100%',
              maxWidth: 400,
              backgroundColor: '#4949C8',
              color: '#fff',
              boxShadow: 'none',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 400,
              '&:hover': {
                backgroundColor: '#3535a8',
              },
            }}
            onClick={handleGoToNextPage}
          >
            Continue
          </Button>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#fafafd',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: 600, textAlign: 'center', mb: 0 }}>
          <Typography
            variant="h5"
            fontFamily="Space Grotesk"
            fontWeight={700}
            color="#4949C8"
            sx={{ mb: 1 }}
          >
            This is what we found about <br /> your business
          </Typography>
          <Typography variant="subtitle1" color="#222" sx={{ mb: 4 }}>
            We automatically pulled this info from your <br /> website.
          </Typography>
        </Box>
        <TestimonialsTwoCarousel />
      </Grid>
    </Grid>
  );
};
